import { useReduxState } from 'hooks';
import { CSSProperties } from 'react';

interface Props {
  borderWidth?: number;
  color?: string;
  padding?: number;
  style?: CSSProperties;
  size?: number;
}

const LoadingIndicator = ({
  borderWidth,
  color,
  padding = 50,
  size = 30,
  style
}: Props) => {
  const { theme } = useReduxState();

  return (
    <div className="loading" style={style}>
      <div className="indicator" style={{ height: size, width: size }}>
        <div
          className="indicator-inner"
          style={{
            borderRadius: size,
            height: size,
            width: size,
            marginLeft: -0.5 * size,
            marginTop: -0.5 * size
          }}
        />
      </div>
      <style jsx>{`
        .loading {
          padding: ${padding}px;
          text-align: center;
        }
        .indicator {
          display: inline-block;
          position: relative;
        }
        @keyframes loadingindicator {
          0% {
            transform: rotate(0deg);
          }
          100% {
            transform: rotate(360deg);
          }
        }
        .indicator-inner {
          animation: loadingindicator 1s infinite linear;
          border: ${borderWidth || 2}px solid ${color || theme.textColor};
          border-top-color: transparent;
          box-sizing: border-box;
          content: '';
          position: absolute;
          top: 50%;
          left: 50%;
        }
      `}</style>
    </div>
  );
};

export default LoadingIndicator;
